export class PublicTenant {
    name: string;
    domainUrl: string;
    language: "EN" | "NL";
    appName: string;
}
